import React, { FC, useEffect, useState } from 'react'
import { SessionType } from '../SessionContainer/SessionContainer'
import { StyledCardItem, StyledModal } from './styled'
import { SessionButtonState } from './SessionButtonState'
import { Modal } from 'react-bootstrap'
import BackIcon from '../../../images/icons/back-btn.png'
import { useHistory } from 'react-router'
// import routes from 'src/routes'

export const SessionCardItem: FC<SessionType> = ({
  hasAccess,
  id,
  title,
  aboutHtml,
  day,
  date,
  description,
  startTime,
  endTime,
  presenters,
  secondsTillStart,
  durationInSeconds,
  hasPlayback,
  ended,
  currentUser,
}) => {
  const history = useHistory()
  const [presenter, setPresenter] = useState(null)
  const [aboutContent, setAboutContent] = useState(null)
  const [dropdown, setDropdown] = useState(
    document.querySelector('.chq-atc--dropdown')
  )
  useEffect(() => {
    if (dropdown) {
      dropdown.querySelectorAll('a').forEach((node) => {
        node.setAttribute('class', `${id}`)
      })
    }
  }, [dropdown])

  const getDropdown = () => {
    setDropdown(document.querySelector('.chq-atc--dropdown'))
  }

  const toggleProfile = (presenterId) => {
    setPresenter(presenters.filter((i) => i.id === presenterId)[0])
  }

  const viewSessionDescription = () => {
    setAboutContent(aboutHtml)
  }

  const closeProfile = () => {
    setPresenter(null)
  }

  const clearAboutContent = () => {
    setAboutContent(null)
  }

  const clickCard = (e) => {
    console.log(e)
    // if (!e.target.className.includes('clickable')) {
    //   history.push(routes.auditorium1)
    // } 
  }

  return (
    <StyledCardItem ended={ended}>
      <div className="flex-child noselect left" onClick={(e) => clickCard(hasPlayback)}>
        <header>
          <div className="cardContent session-details">
            <p>
              {date} | {day}
            </p>
            <p>
              {startTime} to {endTime}
            </p>
            <p className="session-title" onClick={viewSessionDescription}>
              {title}
            </p>
            <p className="text-secondary font-weight-normal" dangerouslySetInnerHTML={{ __html: description }} />
          </div>
        </header>
        <footer className="mt-3">
          <div className="cardContent">
            {presenters.map((speaker) => (
              <div key={`presenter-${speaker.id}`} className="speaker-profile" onClick={() => toggleProfile(speaker.id)}>
                <img alt="avatar" src={speaker.image} className={speaker.image ? 'avatar rounded-circle clickable' : 'd-none'} />
                <div className='clickable'>
                  <small className="speaker-name clickable">{speaker.name}</small>
                  <br />
                  <small className='font-weight-bold clickable' style={{color: '#fcfcfc'}}>{speaker.category}</small>
                </div>
              </div>
            ))}
          </div>
        </footer>
      </div>

      <div className="flex-child noselect right">
        <header>
          <div className={`cardAction`}>
          
          </div>
        </header>
        <footer>
          <SessionButtonState
            userPassType={currentUser.passType}
            hasPlayback={hasPlayback}
            sessionId={id}
            secondsTillStart={secondsTillStart}
            durationInSeconds={durationInSeconds}
          />
        </footer>
      </div>

      {presenter !== null && (
        <StyledModal backdrop={false} animation={false} show onHide={closeProfile} size="lg" aria-labelledby="presenterProfile" centered>
          {presenter && (
            <Modal.Body>
              <img src={BackIcon} className="close-btn" alt="back icon" onClick={closeProfile} />
              <img src={presenter.image} className="avatar rounded-circle d-block mx-auto mb-3" width="25%" alt={`presenter-${presenter.name}`} />
              <h5 className="presenter-name">{presenter.name}</h5>
              <p className="presenter-title" dangerouslySetInnerHTML={{ __html: presenter.designationHtml }} />
              <small className="desc-text" dangerouslySetInnerHTML={{ __html: presenter.descriptionHtml }} />
            </Modal.Body>
          )}
        </StyledModal>
      )}

      {aboutContent && (
        <StyledModal backdrop={false} animation={false} show size="lg" aria-labelledby="presenterProfile" centered>
          <Modal.Body>
            <img src={BackIcon} className="close-btn" alt="back icon" onClick={clearAboutContent} />
            <h4 className="presenter-name font-weight-bolder">About Session</h4>
            <p className="desc-text" dangerouslySetInnerHTML={{ __html: aboutContent }} />
          </Modal.Body>
        </StyledModal>
      )}
    </StyledCardItem>
  )
}